module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar2-minus-fill-86a8ec63.svg";